import React, { Component } from 'react';
import Route from 'react-router-dom/Route';
import PropTypes from 'prop-types';
import './styles.css';
import { BUSINESSPLAN } from '../../routes';
import SetVariableMutation from '../../mutations/SetVariable';
import GameQuery from '../../query/GameQuery';

class Input extends Component {
	constructor(props) {
		super(props);
		this.state = { value: props.variable.value };
	}

	render() {
		const { variable, min, max, step } = this.props;
		return (
			<Route
				path={BUSINESSPLAN}
				render={() => (
					<GameQuery>
						{
							query => (
								<SetVariableMutation>
									{setVariable => (
										<input
											onBlur={this.handleSave.bind(this, setVariable, query.game)}
											onChange={e => this.setState({ value: e.target.value })}
											className={`input-number ${
												!variable.disabled
													? 'input-number-active'
													: 'input-number-disabled'
											}`}
											type="number"
											value={this.state.value}
											min={min}
											max={max}
											step={step || 1}
											pattern="[0-9\.]*"
											disabled={variable.disabled}
										/>
									)}
								</SetVariableMutation>
							)
						}
					</GameQuery>
				)}
			/>
		);
	}
	handleSave(setVariable, game) {
		const { variable, min, max } = this.props;
		const newValue = Math.max(min, Math.min(max, this.state.value));
		const {
			name,
			year,
		} = variable;
		this.setState({ value: newValue });
		setVariable({
			variables: {
				gameID: game.id,
				submission:game.lastSubmission,
				name,
				year,
				value: newValue
			}
		});
	}
}
Input.propTypes = {
	variable: PropTypes.shape({
		value: PropTypes.number,
		disabled: PropTypes.bool,
		_id: PropTypes.string
	})
};
Input.defaultProps = {
	min: 0,
	max: +Infinity
};

export default Input;
